export const EXPERIMENTS_COOKIE = 'segmentation_ongoing';

export default null;
